import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { PROVISIONAL_OFFER_TERM } from '../../../../constants/heapEvents';
import { track } from '../../../../lib/heapHelpers';

import './index.scss';

const LoanTermSelector = ({
  applicationId,
  customerGuid,
  offerOptions,
  selectedOffer,
  onSelectedOfferChange,
  cosignerSelection,
  offerAccepted,
}) => {
  const handleSelectedOfferChange = index => {
    const offerOption = filteredOfferOptions[index];
    onSelectedOfferChange(offerOption);

    track(PROVISIONAL_OFFER_TERM, {
      'Application GUID': applicationId,
      'Customer GUID': customerGuid,
      'Loan type': offerOption.loan_type,
      'Selected term': offerOption.term_in_months,
    });
  };

  const filteredOfferOptions = offerOptions.filter(option =>
    cosignerSelection === 'cosigner'
      ? option.loan_type === 'cosigner_inschool'
      : option.loan_type === 'standard',
  );

  useEffect(() => {
    if (!offerAccepted) {
      const offerOption = filteredOfferOptions[0];
      onSelectedOfferChange(offerOption);
    }
  }, []);

  return (
    <div className="loan-term-selector-v3 h6">
      <ul className="loan-term-selector-v3__grid">
        {filteredOfferOptions.map((offerOption, index) => {
          const selected =
            offerOption.offer_guid === selectedOffer.offer_guid
              ? 'h6 loan-term-button selected'
              : 'h6 loan-term-button';
          const selectedText =
            offerOption.offer_guid === selectedOffer.offer_guid ? 'selected-text' : '';
          const term = offerOption.term_in_months / 12;

          const onClick = () => {
            handleSelectedOfferChange(index);
          };

          return (
            <li
              className={`${selected} ${offerAccepted ? 'disabled' : ''}`}
              onClick={onClick}
              key={index}
            >
              <span className={`${selectedText} loan-term-selector-v3__term`}>
                {term}&nbsp;years
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

LoanTermSelector.propTypes = {
  offerOptions: PropTypes.arrayOf(
    PropTypes.shape({
      offer_guid: PropTypes.string.isRequired,
      term_in_months: PropTypes.number.isRequired,
      monthly_repayment: PropTypes.string.isRequired,
      loan_type: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedOffer: PropTypes.shape({
    offer_guid: PropTypes.string.isRequired,
  }).isRequired,
  onSelectedOfferChange: PropTypes.func.isRequired,
  cosignerSelection: PropTypes.string.isRequired,
  offerAccepted: PropTypes.bool.isRequired,
};

export default LoanTermSelector;
